import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import Consultation from "@/pages/Consultation";
import About from "@/pages/About";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import WhatsAppModal from "@/components/WhatsAppModal";
import { Toaster } from "sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/consultation" element={<Consultation />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppFloat />
        <WhatsAppModal />
        <Toaster
          position="bottom-center"
          toastOptions={{
            style: {
              background: '#2C1E16',
              color: '#F9F6F0',
              border: '1px solid #4A0E17',
              borderRadius: 0,
              fontFamily: 'Manrope, sans-serif',
              letterSpacing: '0.04em',
              fontSize: '12px',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
